export default "__VITE_ASSET__DDpKfwtZ__"